var map = {
	"./0key.png": 47881,
	"./10key.png": 49290,
	"./11key.png": 1097,
	"./12key.png": 4608,
	"./1key.png": 47658,
	"./2key.png": 55911,
	"./3key.png": 80704,
	"./4key.png": 67813,
	"./5key.png": 84230,
	"./6key.png": 62515,
	"./7key.png": 74140,
	"./8key.png": 60881,
	"./9key.png": 24018
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63158;